import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface LeftArrowIconProps {
  width?: number;
  height?: number;
  stroke?: string;
  fill?: string;
}

const LeftArrowIcon = ({ 
    width = 16, 
    height = 16, 
    stroke = '#6B7280',
    fill = 'none'
}: LeftArrowIconProps) => {
  return (
    <SVGUniqueID>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill={fill}>
        <path d="M10 12L6 8L10 4" stroke={stroke} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </SVGUniqueID>
  );
};

export { LeftArrowIcon };